module.exports = __webpack_public_path__ + "img/key.b820d96d.svg";